import { Linking } from "react-native";
export default (url) => {
    void Linking.openURL(url);
};
